import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

type AnswerValue = string | string[]
type Answers = Record<string, AnswerValue>

type NavigationState = {
  currentSlug: string
}

type QuizStore = {
  answers: Answers
  nav: NavigationState
  getAnswer: (name: string) => AnswerValue | undefined
  setSingle: (name: string, value: string) => void
  toggleMulti: (name: string, value: string) => void
  clearAnswer: (name: string) => void
  setCurrentSlug: (slug: string) => void
  resetAll: () => void
}

const STORAGE_KEY = 'cleaner-quiz/v1'

export const useQuizStore = create<QuizStore>()(
  persist(
    (set: any, get: any) => ({
      answers: {},
      nav: { currentSlug: 'welcome' },

      getAnswer: (name: any) => get().answers[name],

      setSingle: (name: any, value: any) =>
        set((state: QuizStore) => ({ answers: { ...state.answers, [name]: value } })),

      toggleMulti: (name: any, value: any) =>
        set((state: QuizStore) => {
          const current = state.answers[name]
          if (!current) return { answers: { ...state.answers, [name]: [value] } }
          if (Array.isArray(current)) {
            const exists = current.includes(value)
            const next = exists ? current.filter((v) => v !== value) : [...current, value]
            return { answers: { ...state.answers, [name]: next } }
          }
          return { answers: { ...state.answers, [name]: [value] } }
        }),

      clearAnswer: (name: any) =>
        set((state: QuizStore) => {
          const { [name]: _, ...rest } = state.answers
          console.log({ answers: _ })

          return { answers: rest }
        }),

      setCurrentSlug: (slug: string) => set({ nav: { currentSlug: slug } }),

      resetAll: () => set({ answers: {}, nav: { currentSlug: 'welcome' } }),
    }),
    {
      name: STORAGE_KEY,
      version: 1,
      storage: createJSONStorage(() => localStorage),
      partialize: (state: any) => ({ answers: state.answers, nav: state.nav }),
      migrate: (persisted: any) => {
        return persisted as any
      },
    },
  ),
)
